package features.notifications.domain

/**
 * Notification domain model
 * @param id Firestore document ID
 * @param userId User who receives the notification
 * @param type Notification type (e.g., "overtime_approved", "overtime_rejected")
 * @param title Notification title
 * @param message Notification message
 * @param isRead Whether the notification has been read
 * @param createdAt Timestamp when notification was created
 * @param relatedId Optional ID of related entity (e.g., overtime request ID)
 */
data class Notification(
    val id: String,
    val userId: String,
    val type: String,
    val title: String,
    val message: String,
    val isRead: Boolean = false,
    val createdAt: String,
    val relatedId: String? = null
)
